module.exports = __webpack_public_path__ + "static/media/back@2x.3211eb83.jpg";